module.exports = __webpack_public_path__ + "d2d0703ca2ce707c4541001947c3abd2.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/system/assets/img/sidebar-menu-arrow.png
 ** module id = 385
 ** module chunks = 0
 **/